var exports = {
  "lm": "LanguageTab.module__notice___NFNGNz",
  "ut": "LanguageTab.module__noticeText___NFNGNz",
  "nf": "LanguageTab.module__link___NFNGNz",
  "XG": "LanguageTab.module__languageSelect___NFNGNz",
  "pK": "LanguageTab.module__languageControls___NFNGNz",
  "e5": "LanguageTab.module__timeControls___NFNGNz",
  "_9": "LanguageTab.module__languageOption___NFNGNz",
  "Ri": "LanguageTab.module__languageOptionMenu___NFNGNz",
  "l5": "LanguageTab.module__languageDetails___NFNGNz",
  "aX": "LanguageTab.module__languageCode___NFNGNz",
  "Eb": "LanguageTab.module__flagImage___NFNGNz",
  "TU": "LanguageTab.module__flagImageText___NFNGNz",
  "hx": "LanguageTab.module__languageOptionCompact___NFNGNz",
  "cL": "LanguageTab.module__languageName___NFNGNz",
  "X6": "LanguageTab.module__languageOptionSelected___NFNGNz",
  "rv": "LanguageTab.module__tooltipContent___NFNGNz",
  "HE": "LanguageTab.module__tooltipText___NFNGNz",
  "QT": "LanguageTab.module__switchWrapper___NFNGNz",
  "Kx": "LanguageTab.module__spellcheckHint___NFNGNz",
  "OO": "LanguageTab.module__spellcheckRestartBanner___NFNGNz",
  "Ru": "LanguageTab.module__dictionaryGrid___NFNGNz",
  "b": "LanguageTab.module__dictionaryRow___NFNGNz",
  "CG": "LanguageTab.module__dictionaryRowChecked___NFNGNz",
  "mj": "LanguageTab.module__dictionaryName___NFNGNz",
  "P": "LanguageTab.module__dictionaryTag___NFNGNz",
  "Wc": "LanguageTab.module__manualDictionaryBlock___NFNGNz",
  "uW": "LanguageTab.module__personalDictAddRow___NFNGNz",
  "bU": "LanguageTab.module__personalDictInput___NFNGNz",
  "rj": "LanguageTab.module__personalDictList___NFNGNz",
  "ze": "LanguageTab.module__personalDictChip___NFNGNz",
  "nm": "LanguageTab.module__personalDictChipRemove___NFNGNz",
  "ib": "LanguageTab.module__personalDictEmpty___NFNGNz",
};

module.exports = exports;
